var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeoff = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m17.202 9.125 1.9 1.888 1.902-1.888.986.993L20.096 12l1.894 1.882-.987.993-1.9-1.888-1.9 1.888-.987-.993L18.11 12l-1.895-1.882.987-.993ZM13.634 3.893a.7.7 0 0 1 .351.607v15a.7.7 0 0 1-1.052.605L6.668 16.45H4.286c-1.078 0-1.986-.853-1.986-1.95v-5c0-1.097.908-1.95 1.986-1.95h2.382l6.265-3.655a.7.7 0 0 1 .701-.002ZM12.585 5.72 7.046 8.95h-2.76a.568.568 0 0 0-.586.55v5c0 .286.243.55.586.55h2.76l5.54 3.231V5.72Z",
  fill: "currentColor"
})));
export { SvgTypeoff as ReactComponent };
export default __webpack_public_path__ + "b77183121c50f77b2e5f4c002224ba5e.svg";